import * as React from 'react';
import { Box } from '../Box/Box.js';

/** Dotted page control component. */
var PageControlIndicator = function PageControlIndicator(props) {
  var color = props.color,
    current = props.current,
    onClick = props.onClick,
    page = props.page,
    scale = props.scale,
    label = props.label,
    disableClick = props.disableClick,
    translation = props.translation,
    sizePx = props.sizePx;
  var getColor = React.useCallback(function () {
    if (current) {
      switch (color) {
        case 'dark':
          return 'base.surface';
        default:
          return 'product.primary';
      }
    }
    switch (color) {
      case 'dark':
        return 'base.overlay.inverted';
      default:
        return 'deprecated.neutral.5';
    }
  }, [current, color]);
  var handleClick = React.useCallback(function () {
    if (onClick) onClick(page);
  }, [onClick, page]);
  return /*#__PURE__*/React.createElement(Box, {
    as: disableClick ? undefined : 'button',
    onClick: disableClick ? undefined : handleClick,
    position: "absolute",
    top: "0",
    p: "4",
    transform: "translate3d(".concat(translation, "%, 0, 0)"),
    transition: "transform ease-in-out 0.3s",
    "aria-current": disableClick ? undefined : current,
    "aria-label": disableClick ? undefined : label
  }, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: getColor(),
    borderRadius: "max",
    width: sizePx,
    height: sizePx,
    transform: scale === 1.0 ? undefined : "scale(".concat(scale.toFixed(3), ")"),
    transition: "transform ease-in-out 0.3s, background ease-in-out 0.3s",
    "aria-hidden": "true"
  }));
};
PageControlIndicator.displayName = 'PageControlIndicator';

export { PageControlIndicator };
//# sourceMappingURL=PageControlIndicator.js.map
